/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type ReportListItemStatus = typeof ReportListItemStatus[keyof typeof ReportListItemStatus];


export const ReportListItemStatus = {
  outdatedByDoclist: 'outdatedByDoclist',
  outdatedByTemplate: 'outdatedByTemplate',
  caseProcessing: 'caseProcessing',
  reportProcessing: 'reportProcessing',
  completed: 'completed',
  failed: 'failed',
} as const;
